import React from "react";
import Login from "./Login";
import SendOTP from "./SendOtp";

import VerifyOTP from "./VerifyOTP";
import ForgotPassword from "./ForgotPassword";
import ChangePassword from "./ChangePassword";
export const loginComponents = [
  {
    path: "/verifyOtp",
    exact: true,
    main: (e, props) => <VerifyOTP {...e} data={props} />,
  },
  {
    path: "/login/1",
    exact: true,
    main: (e, props) => <SendOTP {...e} data={props} />,
  },

  {
    path: "/",
    exact: true,
    main: (e, props) => <Login {...e} data={props} />,
  },
  {
    path: "/forgotpassword",
    exact: true,
    main: (e, props) => <ForgotPassword {...e} data={props} />,
  },
  {
    path: "/changepassword",
    exact: true,
    main: (e, props) => <ChangePassword {...e} data={props} />,
  },
];
